export default __webpack_public_path__ + "static/media/Appstore.0326e285.svg";